import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7363e48d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-header" }
const _hoisted_2 = { class: "content" }

import UserInfo from './UserInfo.vue'
import Breadcrumb from './Breadcrumb.vue'
import { computed, ref } from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import { pathMapToBreadcrumbs } from '@/utils/map-menus'
import { IBreadcrumb } from '@/components/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-header',
  emits: ["foldChange"],
  setup(__props, { emit: __emit }) {

const emit = __emit
const isFold = ref(false)
const handleFoldChange = () => {
  isFold.value = !isFold.value
  emit('foldChange', isFold.value)
}

const store = useStore()
const route = useRoute()

const breadcrumbs = computed(() => {
  const userMenus = store.state.login.userMenu
  const breadcrumbs: IBreadcrumb[] = pathMapToBreadcrumbs(userMenus, route.path)
  if (breadcrumbs.length == 0) {
    if (route.name == 'UpdatePassword') {
      breadcrumbs.push({ name: '个人管理' })
      breadcrumbs.push({ name: '修改密码', path: route.path })
    }
  }
  return breadcrumbs
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("em", {
      class: _normalizeClass(["fold-menu", isFold.value ? 'el-icon-s-unfold' : 'el-icon-s-fold']),
      onClick: handleFoldChange
    }, null, 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Breadcrumb, { breadcrumbs: breadcrumbs.value }, null, 8, ["breadcrumbs"]),
      _createVNode(UserInfo)
    ])
  ]))
}
}

})